import { lazy, ReactNode, Suspense, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createQueryClient } from "./client";

const Devtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/react-query-devtools").then(module => ({
        default: module.ReactQueryDevtools
      }))
    )
  : null;

export interface QueryProviderProps {
  children: ReactNode;
  client?: QueryClient;
  devtools?: boolean;
}

export default function QueryProvider({ children, client, devtools = !import.meta.env.TEST }: QueryProviderProps) {
  const [queryClient] = useState(() => client ?? createQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {Devtools && devtools && (
        <Suspense fallback={null}>
          <Devtools buttonPosition="bottom-left" initialIsOpen={false} />
        </Suspense>
      )}
    </QueryClientProvider>
  );
}
